import React, { type ComponentProps } from 'react';

import { TextLink } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuMoreInfoTextLink = (props: ComponentProps<typeof TextLink>) => {
  const { children, ...restProps } = props;

  return (
    <TextLink sizeMatch={['16']} underline {...restProps}>
      {children}
    </TextLink>
  );
};
